import { Skeleton } from "@/components/ui/skeleton";

interface BookSearchSkeletonProps {
  count?: number;
  /** Use compact mode for smaller spaces like popovers */
  compact?: boolean;
}

/**
 * Loading skeleton for book search results.
 * Uses fixed heights to prevent layout shifts when results load.
 */
export function BookSearchSkeleton({ count = 3, compact = false }: BookSearchSkeletonProps) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div 
          key={i} 
          className={`flex gap-4 ${compact ? 'p-3' : 'p-4'} rounded-lg border bg-card`}
        >
          {/* Fixed cover size: matches CoverImage size="xs" (48x72) */}
          <Skeleton className="h-[72px] w-12 flex-shrink-0 rounded" />
          <div className="flex-1 min-w-0 space-y-2 py-1">
            {/* Title line - fixed height */}
            <Skeleton className="h-5 w-full max-w-[280px]" />
            {/* Author line - fixed height */}
            <Skeleton className="h-4 w-full max-w-[180px]" />
            {/* Optional third line for year/meta */}
            {!compact && <Skeleton className="h-3 w-20" />}
          </div>
        </div>
      ))}
    </div>
  );
}
